import React from 'react';
import { Box } from '@mui/material';

// CodiWord: Renders the word "codi" with a playful animated face for the "o".
// Usage: <CodiWord /> (inline) – designed to be placed inside Typography.
export const CodiWord = ({ sx = {}, animated = true }) => {
  return (
    <Box
      component="span"
      className="welcome-wave"
      sx={(theme) => ({
        display: 'inline-flex',
        alignItems: 'baseline',
        lineHeight: 1,
        verticalAlign: 'baseline',
        gap: '0.12em',
        // Shared keyframes
        '@keyframes codiBlink': {
          '0%, 96%, 100%': { transform: 'scaleY(1)' },
          '97%, 99%': { transform: 'scaleY(0.1)' },
        },
        '@keyframes codiFloat': {
          '0%, 100%': { transform: 'translateY(0)' },
          '50%': { transform: 'translateY(-1px)' },
        },
        ...sx,
      })}
    >
      {/* c */}
      <Box
        component="span"
        sx={(theme) => ({
          display: 'inline-block',
          fontWeight: 700,
          background: theme.palette.mode === 'dark'
            ? 'linear-gradient(90deg, #ffb74d, #ff7043)'
            : 'linear-gradient(90deg, #4A90E2, #6C5CE7)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        })}
      >
        c
      </Box>

      {/* o as a small animated face */}
      <Box
        component="span"
        aria-label="o"
        sx={(theme) => ({
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '1em',
          height: '1em',
          lineHeight: 1,
          color: 'inherit',
          filter: animated ? 'drop-shadow(0 0 0 rgba(0,0,0,0))' : 'none',
          position: 'relative',
          top: 'calc(0.06em + 1px)', // slightly lower to align baseline visually (+1px)
          left: '1px', // nudge to the right by 1px
          verticalAlign: 'baseline',
          '& svg': {
            display: 'block',
            width: '1em',
            height: '1em',
            transition: 'transform 180ms ease',
            ...(animated ? { animation: 'codiFloat 3.2s ease-in-out infinite' } : {}),
          },
          '&:hover svg': animated ? { transform: 'rotate(-3deg) scale(1.03)' } : {},
        })}
      >
        <svg viewBox="0 0 100 100" role="img" focusable="false">
          {/* Outer ring (the "o") */}
          <circle cx="50" cy="50" r="42" stroke="currentColor" strokeWidth="8" fill="none" />
          {/* Eyes */}
          <g
            className="eyes"
            style={{
              transformOrigin: '50% 42%',
              animation: animated ? 'codiBlink 4.6s ease-in-out infinite' : 'none',
            }}
          >
            <circle cx="35" cy="40" r="6" fill="currentColor" />
            <circle cx="65" cy="40" r="6" fill="currentColor" />
          </g>
          {/* Smile */}
          <path d="M35 65 Q 50 76 65 65" stroke="currentColor" strokeWidth="6" fill="none" strokeLinecap="round" />
        </svg>
      </Box>

      {/* d */}
      <Box
        component="span"
        sx={(theme) => ({
          display: 'inline-block',
          fontWeight: 700,
          color: 'inherit',
        })}
      >
        d
      </Box>

      {/* i */}
      <Box
        component="span"
        sx={(theme) => ({
          display: 'inline-block',
          fontWeight: 700,
          color: 'inherit',
        })}
      >
        i
      </Box>
    </Box>
  );
};

export default CodiWord;
